import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const selectOrderForTrackingSchedule = (orderSequence) => ({
  'type': ActionTypes.SELECT_ORDER_FOR_TRACKING_SCHEDULE,
  'payload': orderSequence,
});

export const getOrderTrackingSchedule = (orderSequence) => apiActionCreator({
  'endpoint': `/orders/dealers/tracking/${orderSequence}`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_ORDER_TRACKING_SCHEDULE_REQUEST,
    [
      ActionTypes.GET_ORDER_TRACKING_SCHEDULE_SUCCESS,
    ],
    [
      ActionTypes.GET_ORDER_TRACKING_SCHEDULE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const updateOrderTrackingStep = (orderSequence, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/orders/dealers/tracking/${orderSequence}`,
      'authenticated': true,
      'types': [
        ActionTypes.UPDATE_ORDER_TRACKING_STEP_REQUEST,
        [
          () => {
            dispatch(getOrderTrackingSchedule(orderSequence));

            return {
              'type': ActionTypes.UPDATE_ORDER_TRACKING_STEP_SUCCESS,
            };
          },
        ],
        [
          ActionTypes.UPDATE_ORDER_TRACKING_STEP_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};
